import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SkillDiagnosisBody',
  props: {
    state: null,
    isYagiPrime: { type: Boolean },
    canDiagnose: { type: Boolean },
    hasResumeData: { type: Boolean },
    needsJobHistory: { type: Boolean },
    insufficientMessage: null,
    errorMessage: null,
    zoneDisplayName: null,
    showSkipOption: { type: Boolean },
    hidePopupFor10Days: { type: Boolean },
    result: null
  },
  emits: ["run", "reset", "pay", "toggle-skip"],
  setup(__props: any) {





return { __sfc: true, }
}

})